import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import data from './data';
import { TABLET_WIDTH } from '../../constants/dims';
import imgResearch from '../../assets/img/ourResearch.png';

const Container = styled.section`
  width: 100%;
  position: relative;
  color: ${props => props.theme.ourResearch.text};
  background-color: ${props => props.theme.ourResearch.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  width: 100%;
  height: 436px;
  background-image: url(${imgResearch});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;

  & > .text {
    width: 100%;
    height: 100%;
    padding: 40px;
    box-sizing: border-box;
    color: white !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    & > h2,
    p {
      text-shadow: 0px 0px 10px black;
      opacity: 1;
    }
  }
`;

const Canvas = styled.div`
  width: 100%;
  max-width: ${TABLET_WIDTH}px;
  padding: 40px 32px;
  box-sizing: border-box;

  & > .row {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 42px;

    & .left {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: center;
      flex: 1 1 152px;
      margin-right: 16px;
      margin-bottom: 24px;
      box-sizing: border-box;

      & img {
        width: 152px;
      }
    }

    & .right {
      flex: 1 1 700px;
      min-width: 300px;
    }
  }
`;

const Research = () => {
  useEffect(() => {
    document.title = 'Brainquake: Research';
  }, []);

  return (
    <Container>
      <Header>
        <div className="text">
          <h2>The BrainQuake Mathematics Matters Research Project&trade;</h2>

          <p>
            BrainQuake’s cognitive breakthroughs are the focus of a growing
            number of research projects around the world.
          </p>
        </div>
      </Header>

      <Canvas>
        {data.map((d, i) => (
          <div className="row" key={i}>
            <div className="left">
              <img src={d.img} alt="logo" />
            </div>

            <div className="right">
              {d.title && <h4>{d.title}</h4>}

              {d.description.map((text, i) => (
                <p key={i} dangerouslySetInnerHTML={{ __html: text }} />
              ))}

              {d.links && (
                <p>
                  {d.links.map((l, i) => (
                    <React.Fragment key={i}>
                      <a href={l.url} target="_blank" rel="noopener noreferrer">
                        {l.name}
                      </a>
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              )}
            </div>
          </div>
        ))}
      </Canvas>
    </Container>
  );
};

export default Research;
